angular.module('mercury.modules.reports.cogs')
.config(["$stateProvider", function($stateProvider) {
  // Cost of Goodss
  $stateProvider.state('Reports.CogsSummary', {
    url: '/cogs/summary?report',
    templateUrl: 'modules/reports/cogs/summary.tpl.html',
    controller: 'ReportsCogsSummaryCtrl'
  });

  // Product Analysis
  $stateProvider.state('Reports.CogsProduct', {
    url: '/cogs/product?report&category',
    templateUrl: 'modules/reports/cogs/product.tpl.html',
    controller: 'ReportsCogsProductCtrl'
  });

  $stateProvider.state('Reports.CogsProduct.EditDialog', {
    url: '/editlinks/:posItemId/:posItemName',
    data: {
      menuLinkState: 'Reports.CogsProduct',
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        backdrop: 'static',
        templateUrl: 'modules/reports/cogs/positemlink.tpl.html',
        controller: 'ReportsCogsPosItemLinksCtrl',
        size: 'lg'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });

  $stateProvider.state('Reports.CogsProduct.EditDialog.RecipeView', {
    url: '/editlinks/:posItemId/:posItemName/viewrecipe/:recipeId',
    data: {
      menuLinkState: 'Reports.CogsProduct',
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        backdrop: 'static',
        templateUrl: 'modules/stock/recipe/viewdialog.tpl.html',
        controller: 'StockRecipeViewDialogCtrl',
        size: 'lg'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });

  $stateProvider.state('Reports.CogsProduct.EditDialog.PurchaseHistory', {
    url: '/editlinks/:posItemId/:posItemName/purchasehistory/:stockitemId',
    data: {
      menuLinkState: 'Reports.CogsProduct',
      dialogState: true
    },
    onEnter: ['$state', 'dialog', function($state, dialog) {
      dialog.open({
        backdrop: 'static',
        templateUrl: 'modules/reports/cogs/purchasehistory.tpl.html',
        controller: 'CogsPurchaseHistoryCtrl',
        size: 'lg'
      }).catch(function() {
        $state.go('^', null, {location: 'replace'});
      });
    }],
    onExit: ['dialog', function(dialog) {
      dialog.close();
    }]
  });

  // Purchases
  $stateProvider.state('Reports.CogsPurchases', {
    url: '/cogs/purchases?report',
    templateUrl: 'modules/reports/cogs/purchases.tpl.html',
    controller: 'ReportsCogsPurchasesCtrl'
  });

}]);
